import axiosClient, { axiosWithAuth } from '@/services/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

// Thunks
export const fetchProductRatings = createAsyncThunk(
  'ratings/fetchProductRatings',
  async ({ productSlug, queryParams = {} }, { rejectWithValue }) => {
    if (productSlug === undefined) {
      return rejectWithValue('Product slug is undefined');
    }
    const queryString = new URLSearchParams(queryParams).toString();
    let url = `/api/products/ratings/${productSlug}/ratings`;
    url += queryString ? `?${queryString}` : '';
    try {
      const result = await axiosClient.get(url);
      return result.data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const postProductRating = createAsyncThunk(
  'ratings/postProductRating',
  async ({ productSlug, ratingData }, { rejectWithValue }) => {
    try {
      const response = await axiosWithAuth().post(
        `/api/products/ratings/${productSlug}/ratings`,
        ratingData,
      );

      return await response.data;
    } catch (error) {
      return rejectWithValue(error.response.data.error);
    }
  },
);

// Helper function to calculate rating summary
export function calculateRatingSummary(state) {
  const totalRatings = state.items.length;
  const distribution = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };

  let totalScore = 0;
  const totalRatingValues = 0;
  state.items.forEach((item) => {
    const { rating } = item;
    if (rating >= 1 && rating <= 5) {
      distribution[rating] += 1;
      totalScore += rating;
    }
  });

  const average = totalRatings ? (totalScore / totalRatings).toFixed(1) : 0;

  state.ratingSummary = {
    average: parseFloat(average),
    totalRatings,
    distribution,
  };
}
